module.exports = __webpack_public_path__ + "static/media/Detail_Icon_02_hovered.ba401b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_02_hovered.png
// module id = 1577
// module chunks = 0